<template>
  <div class="box" style="">
    <!-- <div class="search_result">
      <span class="spanOne">相关内容</span>
      <span class="spanTwo">为你找到约{{ resultList.length }}个结果</span>
    </div> -->
    <div class="result">
      <table>
        <tr
          class="consequence"
          v-for="(item, index) in resultList"
          :key="index"
        >
          <td class="consequence_td">
            <dl>
              <dt>
                <span class="title_entry">
                  {{ item.name }}
                </span>
              </dt>
              <dt class="dt_content">
                <p class="rntry_content" v-html="item.content"></p>
              </dt>
              <dt class="dt_time">
                <span>{{ create_time }}</span>
              </dt>
            </dl>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import { getTitleEntryData } from "@/api/Home.js";
export default {
  data() {
    return {
      content: "",
      create_time:"",
      resultList: [
        // {
        //   name: "编译打包1",
        //   content:
        //     '<p>EduSoho 使用&nbsp;<a href="https://doc.webpack-china.org/" target="_blank">webpack</a>&nbsp;编译打包前端模块，配置文件为&nbsp;<code>webpack.config.js</code>：</p>\r\n\r\n<pre>\r\n<code>module.exports = {\r\n  output: {\r\n    path: &#39;web/static-dist/&#39;,       // 用于生产环境下的输出目录\r\n    publicPath: &#39;/static-dist/&#39;,    // 用于开发环境下的输出目录\r\n  },\r\n  libs: { // 独立打包的类库，共用的依赖，在 twig 页面上调用({% do script([&#39;libs/base.js&#39;]) %})\r\n    &#39;vendor&#39;: [&#39;libs/base.js&#39;], // 可以是一个 JavaScript 文件,\r\n    &#39;jquery-validation&#39;: [&#39;libs/js/jquery-validation.js&#39;],\r\n    &#39;echo-js&#39;: [&#39;echo-js&#39;], // 也可以是一个 NPM 依赖包\r\n    // ...\r\n  },\r\n  noParseDeps: [ // 设置不需要解析的依赖，以加快编译速度\r\n    &#39;jquery/dist/jquery.js&#39;,\r\n    &#39;bootstrap/dist/js/bootstrap.js&#39;,\r\n    // ...\r\n  },\r\n  onlyCopys: [  //对于自成一体的前端模块，纯拷贝该组件下的文件到 `web/static-dist/libs` 目录下\r\n    {\r\n      name: &#39;es-ckeditor&#39;, // 模块的编译打包输出名\r\n      ignore: [ // 需忽略复制的文件及目录\r\n        &#39;**/samples/**&#39;,\r\n        &#39;**/lang/!(zh-cn.js)&#39;,\r\n        &#39;**/kityformula/libs/**&#39;,\r\n      ]\r\n    },\r\n    // ...\r\n  ]\r\n};\r\n</code></pre>\r\n\r\n<h2>实时编译</h2>\r\n\r\n<p>实体编译，用于开发模式下，在对前端模块代码修改后，能实时编译生效。</p>\r\n\r\n<p><strong>启动实时编译服务：</strong></p>\r\n\r\n<pre>\r\n<code>npm run dev\r\n</code></pre>\r\n\r\n<p>启动服务后，默认会在本地启动<a href="http://127.0.0.1:3030/" target="_blank">3030端口</a>的前端模块实时编译服务。</p>\r\n\r\n<p><strong>可用参数：</strong></p>\r\n\r\n<ul>\r\n\t<li><code>port:PORT_NUMBER</code>：指定服务端口。例如：\r\n\r\n\t<pre>\r\n<code>npm run dev port:3000\r\n</code></pre>\r\n\t...</li>\r\n\t<li><code>sourcemap:true</code>：生成 Source map；</li>\r\n\t<li><code>verbose:true</code>： 显示编译详情，开启此选项后，控制台会输出每个文件被编译的详情；</li>\r\n\t<li><code>analyzer:true</code>：开启依赖分析工具，打包后文件过大，需要查看都包含了哪些依赖时使用。</li>\r\n\t<li><code>watch:RESOURCE</code>：指定监听实时编译的资源，以加快实时编译的速度。支持指定Bundle、插件、主题的前端资源，例如：\r\n\t<pre>\r\n<code>npm run dev watch:CustomBundle # 只监听定制开发的前端资源\r\nnpm run dev watch:ExamplePlugin # 只监听 Example 插件的前端资源\r\nnpm run dev watch:example # 只监听 Example 主题的前端资源\r\nnpm run dev watch:CustomBundle,ExamplePlugin # 也可同时监听多个的前端资源\r\n</code></pre>\r\n\t</li>\r\n</ul>\r\n\r\n<h3>&nbsp;Source map</h3>\r\n\r\n<p>在编译打包过程中会对前端模块源码进行压缩、合并、语言转换（CoffeeScript 转换成 JavaScript）等一系列的转换，这使得实际运行的代码不同于开发代码，除错（debug）变得困难重重。开始 Source map 后，会生成一个信息文件，里面储存着位置信息。也就是说，转换后的代码的每一个位置，所对应的转换前的位置。有了它，出错的时候，除错工具将直接显示原始代码，而不是转换后的代码。</p>\r\n\r\n<p>-- 引用自<a href="http://www.ruanyifeng.com/blog/2013/01/javascript_source_map.html" target="_blank">《JavaScript Source Map 详解 - 阮一峰的网络日志》</a></p>\r\n\r\n<h2>编译实体文件</h2>',
        //   create_time: "2022-04-28",
        // },
        // {
        //   name: "编译打包2",
        //   content:
        //     "内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2内容2",
        //   create_time: "2022-04-28",
        // },
        // {
        //   name: "编译打包3",
        //   content: "内容3",
        //   create_time: "2022-04-28",
        // },
      ],
    };
  },
  created() {
    this.content = this.$route.query.content;
    this.getEntryListData();
  },
  watch: {
    $route: {
      handler() {
        this.content = this.$route.query.content;
        this.getEntryListData();
      },
      deep: true,
    },
  },
  methods: {
    //日期时间转换  注释
    rTime(date) {
      var json_date = new Date(date).toJSON();
      return new Date(new Date(json_date) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, " ")
        .replace(/\.[\d]{3}Z/, "");
    },
    async getEntryListData() {
      const { data: res } = await getTitleEntryData(this.content);
      this.create_time=this.rTime(res.ret_data[0].create_time)
      this.resultList = res.ret_data;
      this.$store.commit('changeListLength', this.resultList.length)
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  width: 100% !important;
  text-align: center !important;
  margin: 0 auto;
  width: 800px !important;
  .result {
    max-width: 800px !important;
    z-index: 9999999;
    padding: 23px 0 43px 0;

    table {
      height: 148px;
      text-align: left;
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius:8px;
      border-bottom: 0 !important;
      .consequence {
        background: rgba(0, 0, 0, 0.05);
        
        .consequence_td {
          padding: 20px !important;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
          dl{
            margin: 0 0 0 0 !important;
          }
          .title_entry {
            height: 16px;
            font-size: 16px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #ffffff;
            line-height: 24px;
          }
          .dt_content {
            // padding-top: 10px;
            .rntry_content {
               width: 800px !important;
              margin: 0 0 !important;
              font-size: 14px;
              font-family: SourceHanSansCN-Regular, SourceHanSansCN;
              font-weight: 400;
              color: rgba(255, 255, 255, 0.8);
              line-height: 24px;
              height: 60px;
              overflow: hidden !important;
              text-overflow: ellipsis !important;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              p{
                margin: 0 0 !important;
              }
            }
          }

          .dt_time {
            padding-top: 10px;
            span {
              font-size: 14px;
              font-family: Roboto-Regular, Roboto;
              font-weight: 400;
              color: rgba(255, 255, 255, 0.6);
              line-height: 16px;
            }
          }
        }
      }
    }
  }
}
</style>